<template>
  <el-form-item
    :label="form.name"
    :prop="form.model"
    :class="[form.options.required?'label-blue':'']"
    :rules="((form.rules.length>0&&form.rules[0].required)?rules:form.rules)"
    :required="form.options.required"
    v-show="!form.options.hidden"
    style="padding-left:10px;line-height:36px;"
  >

    <el-select style="width:226px" :disabled="inputDisable" v-model="value[form.modelLabel]" filterable
               :filter-method="filterSelect" @focus="getOrg" placeholder="请选择" @clear="clear" ref="selectReport"
               clearable>
      <el-option :label="value[form.modelLabel]" :value="0"
                 style="width: 380px;height:auto;background-color:#fff;padding: 0;">
        <el-tree
                ref="tree"
                style="width:100%;"
                :data="optionData"
                :filter-node-method="filterNode"
                node-key="id"
                :props="{label:'text',children:form.options.props.children}"
                @node-click="nodeClick">
        </el-tree>
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
export default {
  name: "OrgCascader",
  // components: {},,expandTrigger:'hover' this.$refs.org.dropDownVisible=false;
  data() {
    return {
      loading: false,
      key: "",
      mainValue: [],
      formData: { value: "" },
      optionData: [],
      remoteSearchFunc: () => {},
      dialogVisible: false,
      filterText: "",
      showPop:true,
      nowValue:'',
      rules:[{required: true,message: "单位信息不正确!"}]
    };
  },
  props: {
    form: {
      type: Object,
      default: () => {
        return {
          name: "",
          prop: "",
          icon: "",
          className: "",
          options: {
            defaultValue: [],
            width: "",
            placeholder: "",
            disabled: false,
            clearable: false,
            remote: true,
            remoteOptions: [],
            props: {
              value: "value",
              label: "label",
              children: "children"
            },
            customClass: "", //1管养/2养护
            labelWidth: 100,
            isLabelWidth: false,
            hidden: false,
            dataBind: true, //管养（true）//养护(false)
            showLast: false,
            remoteFunc: () => {},
            remoteSearch: false,
            remoteSearchFunc: () => {}
          },
          key: "",
          model: "value",
          modelLabel: "value1",
          department: false,
          rules: [{}]
        };
      }
    },
    value: Object,
    forms: {
      type: Object,
      default: () => {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    value: {
      immediate: true,
      handler(val) {
        this.mainValue = val;

      }
    },
    "form.options.remoteOptions": function(newVal, oldVal) {
      this.optionData = newVal;
    }
  },
  methods: {
    filterSelect(value){
      this.filterText = value
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.text.indexOf(value) !== -1;
    },
    initHandle(){
      let  that = this
      if(that.value!=""){
        // 初始化显示
        let node = that.$refs.tree.getNode(that.value[that.form.model])

        if(node){
           that.value[that.form.modelLabel] = node.data[that.props.label]
        }else{
          that.clear()
        }
      }else{
        that.value[that.form.modelLabel] =''
      }

    },
    onInput(val) {
    //   let that = this;
    //   let nodes = this.$refs.org.getCheckedNodes();
    //   if (nodes.length > 0) {
    //     this.value[this.form.modelLabel] = nodes[0].label;
    //   } else {
    //     this.value[this.form.modelLabel] = "";
    //   }
    //   val == null && (this.value[this.form.model] = "");
    //   this.$emit("input", that.form.model, that.mainValue);
    //   if (typeof that.form.options.changeFunc === "function") {
    //     that.form.options.changeFunc(
    //       that.value[that.form.model],
    //       that,
    //       that.forms
    //     );
    //   }
    },
    //获取组织机构
    getOrg() {
      let layers = "1";
      if(this.form.options.customClass&&this.form.options.customClass != ""){
        this.form.options.customClass != "" &&(layers = this.form.options.customClass);
      }
      if(layers=="9"){
        this.$http.postX(this.$url.authority.getownerlist, {})
        .then(res => {
          this.optionData = res.data;
        });
      }else if(layers=="22"){
        this.$http.postX(this.$url.authority.gettreelist, { layer: 2, useType:2 })
        .then(res => {
          this.optionData = this.getTreeData(res.data);
        });
      }else{
        this.$http.postX(this.$url.authority.gettreelist, { layer: layers })
        .then(res => {
          this.optionData = this.getTreeData(res.data);
        });
      }
    },
    getTreeData(data) {
      // 循环遍历json数据
      for (var i = 0; i < data.length; i++) {
        if (data[i].children == undefined && data[i].children==null && data[i].children.length < 1 ) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.getTreeData(data[i].children);
        }
      }
      return data;
    },
    //节点被点击
    nodeClick(data, checked, event) {
              this.value[this.form.model] = data.id
             this.value[this.form.modelLabel] = data.text;
              this.$refs.selectReport.blur()
    },
    yes() {
      this.dialogVisible = false;
    },
    clear(){
         this.value[this.form.model] = "";
         this.value[this.form.modelLabel] = "";
         this.filterText = ""
    },
    treeShow(){
        this.dialogVisible=true
        this.$emit('popoverShow',this.dialogVisible)
    }
  },
  created() {
    //在初次加载的时候，将是否开启部门搜索设置为false
    if (this.form.department === undefined) {
      this.form.department = false;
    }
  // this.getOrg()
  },
  mounted() {
    let that = this;
    that.$emit("init", that.key, that);
    //点击文本就让它自动点击前面的input就可以触发选择。但是因组件阻止了冒泡，暂时想不到好方法来触发。
    //这种比较耗性能，暂时想不到其他的，能实现效果了。
    setInterval(function() {
      document.querySelectorAll(".el-cascader-node__label").forEach(el => {
        el.onclick = function() {
          if (this.previousElementSibling) this.previousElementSibling.click();
        };
      });
    }, 1000);
  },
  computed: {
    inputDisable() {
      return this.disabled || this.form.options.disabled;
    }
  }
};
</script>

<style scoped>
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Customize/OrgTree.vue"
}
</vue-filename-injector>
